import React from "react";
import styles from "./Auction.module.sass";
import { useHistory } from "react-router";

const Row = ({ data }) => {
	const history = useHistory();
	return (
		<div
			className={styles.row}
			onClick={() => {
				history.push(`/customers/list/customer/` + data.user?._id);
			}}
		>
			<div className={styles.col}>{data.user.userName}</div>
			<div className={styles.col}>
				{data.last_amount} {data.currency}
			</div>
			<div className={styles.col}>
				{new Date(data.createdAt).toLocaleString()}
			</div>
		</div>
	);
};

export default Row;
